import React from 'react';
import get from 'lodash/get';
import axios from '../utils/ajax';
import CMSComponent from '../components/CMSComponent';
import Page404 from './404';
import { DEFAULT_ZIPCODE } from '../constants/default';
import pageDisable from '../helpers/pageDisableHelper';
import * as WEBSITES from '../constants/website';
import getHost from '../helpers/gethost';
import { withConfig } from '../lib/withConfig';

const canonicalHref = `https://${getHost()}/privacypolicy`;

function PrivacyPolicy({ html, error }) {
  if (error) {
    return <Page404 showNavbar />;
  }
  return (
    <CMSComponent
      h1Title
      title="Privacy Policy"
      html={html}
      metaDescription={
        process.env.NEXT_PUBLIC_APP === WEBSITES.GRASSDOOR
          ? 'Grassdoor committment to respecting the privacy rights of our customers, visitors, drivers, and other users of the website.'
          : ''
      }
      canonicalHref={canonicalHref}
    />
  );
}

async function getServerSidePropsFunction({ req }) {
  if (process.env.NEXT_PUBLIC_CHECKOUT_ONLY !== 'true') {
    try {
      // Extract the host from the request headers to include in the custom header
      const host = req?.headers?.host === 'localhost:3000'
        ? process.env.NEXT_PUBLIC_FALLBACK_API_URL
        : req?.headers?.host;
      // Make the API request with the custom header
      const response = await axios({
        url: `${process.env.NEXT_PUBLIC_SECURE_EC2_URL}/cms/privacypolicy`,
        method: 'GET',
        headers: {
          zc: DEFAULT_ZIPCODE,
          'saas-domain': host, // Custom header added here
        }
      });

      // Extract and process the response data
      const responseData = get(response, 'data.data', {});
      let html = responseData.description;

      // Extract and clean up <script> tags
      const first = html.indexOf('<script>') !== -1 ? html.indexOf('<script>') + '<script>'.length : -1;
      const last = html.indexOf('</script>');
      const script = first !== -1 && last !== -1 ? html.substring(first, last) : '';

      html = html.replace('<script>', '').replace('</script>', '').replace(script, '');
      responseData.description = html;
      responseData.script = script;

      // Return props with the processed data
      return {
        props: { html: responseData }
      };
    } catch (error) {
      console.error('Error in getServerSidePropsFunction (Privacy Policy):', error);
      return { props: {} };
    }
  }

  // Return default props if the condition is not met
  return { props: {} };
}

// Export the function using `withConfig`
export const getServerSideProps = withConfig(getServerSidePropsFunction);

export default pageDisable(PrivacyPolicy);
